import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const ContentWrapper = styled.section`
	display: flex;
	flex-direction: column;
	margin-bottom: 100px;

	${media.belowLarge`
		margin-bottom: 40px;
	`}
`;

export const StyledHeading1 = styled.h1`
	font-size: 4.8rem;
	font-weight: 700;
	line-height: 1;
	margin: 40px 0 8px;

	${media.belowLarge`
		font-size: 3.2rem;
		line-height: 1.1875;
		margin: 32px 0 16px;
	`}
`;

export const StyledHeading2 = styled.h2`
	font-size: 3.2rem;
	font-weight: 700;
	line-height: 1.1875;
	margin: 32px 0 8px;

	${media.belowLarge`
		font-size: 2.4rem;
		line-height: 1.25;
		margin: 24px 0 8px;
	`}
`;

export const StyledHeading3 = styled.h3`
	font-size: 2.4rem;
	font-weight: 700;
	line-height: 1.25;
	margin: 24px 0 0;

	${media.belowLarge`
		font-size: 2.0rem;
	`}
`;

export const StyledHeading4 = styled.h4`
	font-size: 2rem;
	font-weight: 700;
	line-height: 1.25;
	margin: 20px 0 0;

	${media.belowLarge`
		font-size: 1.8rem;
	`}
`;

export const StyledHeading5 = styled.h5`
	font-size: 1.8rem;
	font-weight: 700;
	line-height: 1.25;
	margin: 20px 0 0;

	${media.belowLarge`
		font-size: 1.6rem;
	`}
`;

export const StyledHeading6 = styled.h6`
	font-size: 1.8rem;
	font-weight: 600;
	line-height: 1.25;
	margin: 16px 0 0;

	${media.belowLarge`
		font-size: 1.6rem;
	`}
`;

export const StyledHorizontalRule = styled.hr`
	background-color: ${({ theme }) => theme.colors.line};
	border: 0;
	height: 1px;
	margin: 8px 0;
	width: 100%;
`;

export const StyledIframe = styled.iframe.attrs({ height: 394, width: 700 })`
	margin: 16px auto 8px;
	max-width: 100%;
`;

export const StyledImageContainer = styled.span`
	display: flex;
	justify-content: center;
	margin: auto;
	max-width: 460px;
	width: 100%;
`;

export const StyledImage = styled.img`
	display: block;
	margin: auto;
	max-width: 100%;
`;

export const StyledInstagramContainer = styled.span`
	& > iframe {
		margin: 16px auto 8px !important;
	}
`;

export const StyledListItem = styled.li`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 1.5;
`;

export const StyledOrderedList = styled.ol`
	margin: 16px 0 8px;
`;

export const StyledParagraph = styled.p`
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 1.5;
	margin: 16px 0 8px;
`;

export const StyledPre = styled.pre`
	white-space: pre-wrap;
`;

export const StyledUnorderedList = styled.ul`
	margin: 16px 0 8px;
`;
